module.exports = __webpack_public_path__ + "media/Step2.495d7cc0.webm";